// extracted by mini-css-extract-plugin
module.exports = {"backButton":"SidebarPopupBackButton__backButton__i4c3h"};